import React from 'react';
import { useNavigate } from 'react-router-dom';
import { XCircle } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';

export default function SubscriptionCancel() {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-background flex items-center justify-center p-4">
      <Card className="w-full max-w-md border-2 shadow-xl" data-testid="subscription-cancel">
        <CardHeader className="text-center">
          <div className="mx-auto w-16 h-16 rounded-full bg-slate-100 flex items-center justify-center mb-4">
            <XCircle className="w-8 h-8 text-slate-500" />
          </div>
          <CardTitle className="text-2xl">Payment Cancelled</CardTitle>
          <CardDescription>Your subscription was not changed</CardDescription>
        </CardHeader>

        <CardContent className="space-y-4">
          <div className="bg-slate-50 border border-slate-200 rounded-lg p-4 text-sm text-slate-700">
            <p>No charges were made to your account. You can try again whenever you're ready.</p>
          </div>

          <div className="flex flex-col space-y-2">
            <Button 
              onClick={() => navigate('/pricing')} 
              className="w-full rounded-full"
              data-testid="view-plans"
            >
              View Pricing Plans
            </Button>
            <Button 
              variant="outline" 
              onClick={() => navigate('/dashboard')} 
              className="w-full rounded-full"
              data-testid="go-to-dashboard"
            >
              Back to Dashboard
            </Button>
          </div>
        </CardContent>
      </Card>
    </div>
  );
}
